import React, { useState } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import UserIcon from '../../../../icons/user.svg';
import PinLocationIcon from '../../../../icons/pin-location.svg';
import CalendarIcon from '../../../../icons/calendar1.svg';
import NoSmokeIcon from '../../../../icons/no-smoke.svg';
import HeightIcon from '../../../../icons/height.svg';
import ScaleIcon from '../../../../icons/scale.svg';
import ExpandMoreIcon from '../../../../icons/expand-more.svg';
import MaritalStatusIcon from '../../../../icons/MaritalStatusIcon.svg';
import SmokingRoomsIcon from '@material-ui/icons/SmokingRooms';
import Button from '@material-ui/core/Button';
import { Col, Row } from 'react-bootstrap';
import IsJuvenile from '../../../Helpers/Dates/IsJuvenile';
import Age from '../../../Helpers/Dates/Age';
import ConvertToShortHandHeight from '../../../Helpers/Formatters/ShortHandHeight';
import PropTypes from 'prop-types';
import Collapse from '@material-ui/core/Collapse';
import './BasicInfoSummary.scss';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  textColor: {
    color: theme.palette.primary.main
  },
}))

export function BasicInfoSummary(props) {
  const classes = useStyles();
  const isJuvenile = props.birthdate && IsJuvenile(props.birthdate) && props.isJuvenileApp === true;
  const isValidBirthdate = (new Date(props.birthdate) !== "Invalid Date") && !isNaN(new Date(props.birthdate))
  const age = (props.birthdate && isValidBirthdate) ? Age(props.birthdate) : null;
  const smoker = props.tobacco === 'true' ? true : props.tobacco === 'false' ? false : null;
  const height = props.height ? ConvertToShortHandHeight(props.height) : null;
  const weight = props.weight ? (props.weight.includes('pounds') ? props.weight.replace('pounds', 'lbs').replace(' ', '') : props.weight) : null;
  const MaritalStatus = props.MaritalStatus === 'M' ? 'Married' : props.MaritalStatus === 'S' ? 'Single' : null
  const data = [
    {
      icon: PinLocationIcon,
      label: 'State',
      text: props.state
    },
    {
      icon: UserIcon,
      label: 'Gender',
      text: props.gender === 'F' ? 'Female' : props.gender === 'M' ? 'Male' : null
    },
    {
      icon: CalendarIcon,
      label: 'Age',
      text: age ? parseInt(age, 10) : null
    },
    {
      skip: isJuvenile,
      icon: smoker ? SmokingRoomsIcon : NoSmokeIcon,
      label: 'Smoker',
      text: smoker === null ? null : smoker ? 'Yes' : 'No'
    },
    {
      icon: HeightIcon,
      label: 'Height',
      text: height
    },
    {
      icon: ScaleIcon,
      label: 'Weight',
      text: weight
    },
    {
      icon: MaritalStatusIcon,
      label: 'Marital Status',
      text: MaritalStatus
    },

  ];
  return (
    <div className="basic-info-summary d-flex flex-wrap justify-content-center py-2">
      {data.map((d, index) => d.text &&
        <Col key={index} className={`d-flex flex-column px-1 ${d.skip ? 'd-none' : ''}`}>
          <SvgIcon color="primary" component={d.icon} className="mx-auto" aria-label={d.label} id={`${d.label}-${index}`} />
          <div className={`mx-auto ${classes.textColor}`} aria-labelledby={`${d.label}-${index}`}>{d.text}</div>
        </Col>
      )
      }
    </div>
  )
}
export function CollapsibleBasicInfoSummary(props) {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className="collapsible-basic-info-summary">
      <Row>
        <Col>
          <Button variant="text" className="expand" onClick={() => setExpanded(!expanded)}>
            <b>Summary</b>
            <SvgIcon component={ExpandMoreIcon} className={expanded ? 'expanded' : ''} />
          </Button>
        </Col>
        <Col xs="auto">
          <Button variant="text" color="primary" className="edit" onClick={props.editLinkOnClick}><b>EDIT</b></Button>
        </Col>
      </Row>
      <div>
        {props.showMultipleInsuredInfo ?
          <Collapse in={expanded} className="w-100">
            {props.component}
          </Collapse>
          :
          <Collapse in={expanded} className="w-100">
            <BasicInfoSummary {...props} />
          </Collapse>
        }
      </div>
    </div>
  )
}

BasicInfoSummary.propTypes = {
  gender: PropTypes.string,
  state: PropTypes.string,
  birthDate: PropTypes.string.isRequired,
  tobacco: PropTypes.string,
  MaritalStatus: PropTypes.string
};

CollapsibleBasicInfoSummary.propTypes = {
  gender: PropTypes.string,
  state: PropTypes.string,
  birthDate: PropTypes.string.isRequired,
  tobacco: PropTypes.string,
  MaritalStatus: PropTypes.string,
  editLinkOnClick: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/components/Quoters/Common/SubComponents/BasicInfoSummary.js